import { useIsNewDoctorLauncherEnabled } from './useNewDoctorLauncher';

export const useDoctorViewSwapActive = () => useIsNewDoctorLauncherEnabled();
